import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import Pagination from "../../commanPage/paginationUi/Pagination";
import { useDispatch, useSelector } from "react-redux";
import { getAllTranscationHistory, asyncTransactionsHistoryAction } from "../../../redux/action/wallet";
import TableLoader from "../../commanPage/loader/TableLoader";
import { capitalizeFirstLetter, convertTo12HourFormat } from "../../../helper/helpers";
import { Collapsible, CollapsibleItem } from 'react-materialize'

function TranscationHistory({ searchData }) {
  const dispatch = useDispatch();
  const totalNumberRow = 100;
  const [currentPage, setCurrentPage] = useState(0);
  const isTablet = useMediaQuery({ query: "(max-width: 990px)" });
  const [initialSearchData, setInitialSearchData] = useState([]);
  const [transcationData, setTranscationData] = useState([]);
  const { transcationHistory, transcationHistoryLoading, asyncLoading } = useSelector((state) => state.withdrawalRequest);

  useEffect(() => {
    dispatch(getAllTranscationHistory());
  }, [dispatch])

  useEffect(() => {
    setInitialSearchData(transcationHistory);
    setTranscationData(transcationHistory);
  }, [transcationHistory]);

  useEffect(() => {
    if (searchData?.trim()) {
      const getNestedValue = (obj, path) => {
        return path.split('.').reduce((acc, key) => acc?.[key], obj);
      };

      const filteredData = initialSearchData?.filter((item) =>
        [
          "organization.organizationName",
          "payerName",
          "payerAccNumber",
          "status",
        ].some((field) =>
          getNestedValue(item, field)?.toLowerCase()?.includes(searchData?.trim()?.toLowerCase())
        )
      );

      setTranscationData(filteredData);
    } else {
      setTranscationData(initialSearchData);
    }
  }, [searchData, initialSearchData]);

  function asyncTransactionsHistory() {
    dispatch(asyncTransactionsHistoryAction)
  }

  if (transcationHistoryLoading) {
    return <div className="valign-wrapper justify-center cover white mt-1">
      <TableLoader
        headerData={[
          "Organisation Name",
          "Bank Name",
          "Account No",
          "Date",
          "Amount",
          "Actions",
        ]}
      />
    </div>
  }

  console.log('transactions his', transcationHistory)

  return (
    <>
      <div className={`mt-1 ${!isTablet && "table-container-style"}`}>
        <table
          className={`responsive-table centered ${isTablet ? "auction_table table-style" : "custom-table-style"
            } `}
        >
          <thead>
            <tr>
              <th>#</th>
              <th>Organisation Name</th>
              <th>Bank Name</th>
              <th>Account No</th>
              <th>IFSC code22</th>
              <th>Date</th>
              <th>Amount</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody className="white">
            {transcationData
              ?.slice(currentPage, currentPage + totalNumberRow)
              ?.map((items, index) => (
                items.status !== 'rejected' ?
                  <tr className="white black-text" key={items?._id}>
                    <td>
                      {items.status === "success" ? (
                        <img
                          style={{ width: "30px" }}
                          src={`${process.env.PUBLIC_URL}/icons/${items.amount < 0
                            ? "wallet-minus.svg"
                            : "wallet-add.svg"
                            }`}
                          alt="Icon"
                        />
                      ) : (
                        <img
                          style={{ width: "30px" }}
                          src={`${process.env.PUBLIC_URL}/icons/wallet-pending.svg`}
                          alt="Icon"
                        />
                      )}
                    </td>
                    <td>{items?.organization?.organizationName}</td>
                    <td>{items?.bankAccountDetails?.bankName}</td>
                    <td>{items?.bankAccountDetails?.accountNo}</td>
                    <td>{items?.bankAccountDetails?.IFCSCode}</td>
                    <td>
                      <span>
                        {new Date(items?.updatedAt).toLocaleDateString("en-GB")}
                      </span>
                      <span> {convertTo12HourFormat(items?.updatedAt)}</span>
                    </td>
                    <td>{Math.abs(items.amount)}&nbsp;{items.currency}</td>
                    <td>
                      <span
                        style={{
                          color:
                            items?.status === "approved"
                              ? "green"
                              : items?.status === "rejected"
                                ? "red"
                                : items?.status === "failed"
                                  ? "red"
                                  : items?.status === "completed"
                                    ? "purple"
                                    : "orange",
                        }}
                      >
                        {capitalizeFirstLetter(items.status)}
                      </span>
                    </td>
                    <td>
                      {!transcationHistoryLoading && <button className="btn"
                        disabled={asyncLoading || !transcationHistoryLoading || items?.status != 'initiated'}
                        onClick={asyncTransactionsHistory}
                      >Async</button>}
                    </td>
                  </tr> :
                  <tr key={items?._id}>
                    <td colSpan={8} style={{ padding: 0 }}>
                      <Collapsible accordion={false}>
                        <CollapsibleItem
                          expanded={false}
                          header={
                            <table style={{ width: "100%" }}>
                              <tr>
                                <td>
                                  {items.status === "success" ? (
                                    <img
                                      style={{ width: "30px" }}
                                      src={`${process.env.PUBLIC_URL}/icons/${items.amount < 0 ? "wallet-minus.svg" : "wallet-add.svg"
                                        }`}
                                      alt="Icon"
                                    />
                                  ) : (
                                    <img
                                      style={{ width: "30px" }}
                                      src={`${process.env.PUBLIC_URL}/icons/wallet-pending.svg`}
                                      alt="Icon"
                                    />
                                  )}
                                </td>
                                <td>{items?.organization?.organizationName}</td>
                                <td>{items?.bankAccountDetails?.bankName}</td>
                                <td>{items?.bankAccountDetails?.accountNo}</td>
                                <td>{items?.bankAccountDetails?.IFCSCode}</td>
                                <td>
                                  <span>
                                    {new Date(items?.updatedAt).toLocaleDateString("en-GB")}
                                  </span>
                                  <span> {convertTo12HourFormat(items?.updatedAt)}</span>
                                </td>
                                <td>{Math.abs(items.amount)}&nbsp;{items.currency}</td>
                                <td>
                                  <span
                                    style={{
                                      color:
                                        items?.status === "approved"
                                          ? "green"
                                          : items?.status === "rejected"
                                            ? "red"
                                            : items?.status === "failed"
                                              ? "red"
                                              : items?.status === "completed"
                                                ? "purple"
                                                : "orange",
                                    }}
                                  >
                                    {capitalizeFirstLetter(items.status)}
                                  </span>
                                </td>
                                <td>
                                  <span class="material-symbols-outlined">
                                    keyboard_arrow_down
                                  </span>
                                </td>
                              </tr>
                            </table>
                          }
                        >
                          {items.rejectionReason || '---'}
                        </CollapsibleItem>
                      </Collapsible>
                    </td>
                  </tr>


              ))}
          </tbody>
        </table>
        {(!transcationData || transcationData?.length === 0) && (
          <div className="full-width column grey-text p-1 noItems-height flex align-center justify-center ">
            <span className="material-symbols-outlined large-size ">
              receipt_long
            </span>
            <p>No data found.</p>
          </div>
        )}
      </div>

      <Pagination
        Data={transcationData || []}
        totalNumberRow={totalNumberRow}
        setCurrentPage={setCurrentPage}
      />
    </>
  );
}

export default TranscationHistory;
